import backofficeService from '../../api/backoffice'

export default {
  getInventory(cspid) {
    return backofficeService.Api().get(`cspApi/v2Inventory/inventory/${cspid}`)
      .then(response => response.data.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get All invoice
   * @param {*} params Query Options
   */
  getAllInvoice(id, params) {
    return backofficeService.Api().get(`api/invoice/getInviocesByStoreId/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getInvoiceById(id, storeID) {
    return backofficeService.Api().get(`api/viewInvoice/${storeID}/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  getCardByStore(id) {
    return backofficeService.Api().get(`api/stripe/cards/${id}`)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  updateStore(id, data) {
    return backofficeService.Api().put(`crm/api/update/stores/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All location
   * @param {*} params Query Options
   */
  getAll(id, params) {
    return backofficeService.Api().get(`crm/api/storeByOrganization/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get location profile
   * @param {*} params Query Options
   */
  getbyId(id, params = {}) {
    return backofficeService.Api().get(`crm/api/stores/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getLocationSale(id, params = {}) {
    return backofficeService.Api().get(`cspApi/getSale/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get stripe profile
   * @param {*} params Query Options
   */
  getCreditCards(id, params = {}) {
    return backofficeService.Api().get(`api/stores/${id}`, { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  deleteCard(data) {
    return backofficeService.Api().post('api/stripe/deleteCard', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  switchCard(data) {
    return backofficeService.Api().post('api/stripe/changeDefaultCard', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  addFeature(id, data) {
    return backofficeService.Api().put(`api/add/feature/${id}`, data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  addLocation(data) {
    return backofficeService.Api().post('signup/new/store', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => { throw error })
  },
  
}
